import { render, staticRenderFns } from "./EditableList.vue?vue&type=template&id=8c5880ee&scoped=true&"
import script from "./EditableList.vue?vue&type=script&lang=js&"
export * from "./EditableList.vue?vue&type=script&lang=js&"
import style0 from "./EditableList.vue?vue&type=style&index=0&id=8c5880ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5880ee",
  null
  
)

export default component.exports